import React, { useState } from 'react'

import { Box, Button, Grid, TablePagination } from '@material-ui/core'
import { AssignmentTurnedIn as AssignmentIcon } from '@material-ui/icons'
import { isEmpty } from 'lodash'

import {
  Container,
  ContentHeader,
  FilterButton,
  Filters,
  LoadingFeedback,
  NoData,
  Page,
  Permitted,
} from 'components'
import TrainingCourseCard from './components/TrainingCourseCard'
import TrainingCourseCardSkeleton from './components/TrainingCourseCardSkeleton'
import GenerateReportDialog from './components/GenerateReportDialog'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import usePagination from 'hooks/usePagination'
import usePermissions from 'hooks/usePermissions'

import * as service from 'service'
import useStyles from './styles'

import constants from 'constants/index'

const TrainingCoursesMain = () => {
  const { permitted } = usePermissions()
  const classes = useStyles()
  const filter = useFilter()
  const [reportDialogOpen, setReportDialogOpen] = useState(false)

  const { page, perPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination(12)

  const { response, isLoading } = useFetch(
    service.dponet.trainingCourse.index,
    { page, perPage, ...filter.filters },
    [page, perPage, filter.filters],
  )

  const { response: categoriesResponse } = useFetch(
    service.dponet.trainingCourse.categories,
    {},
    [],
  )

  const courses = response?.data?.courses ?? []
  const totalCount = response?.data?.meta?.totalCount ?? 0
  const categories = categoriesResponse?.data?.categories ?? []

  const isEdit = permitted(constants.permissions.NEW_PLATFORM_COURSE.CONFIG)

  return (
    <Page
      title={
        isEdit
          ? 'Configuração de Treinamentos'
          : 'Visualização dos Treinamentos'
      }
    >
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader
          title={
            isEdit
              ? 'Configuração de Treinamentos'
              : 'Visualização dos Treinamentos'
          }
        >
          {!isEmpty(courses) && (
            <Permitted tag={constants.permissions.NEW_PLATFORM_COURSE.CONFIG}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AssignmentIcon size={18} />}
                onClick={() => setReportDialogOpen(true)}
              >
                Gerar relatório
              </Button>
            </Permitted>
          )}
          <FilterButton setDrawerOpen={filter.setDrawerOpen} />
        </ContentHeader>

        {isLoading ? (
          <Box mt={3}>
            <Grid container spacing={3}>
              {Array.from({ length: perPage }).map((_, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <TrainingCourseCardSkeleton />
                </Grid>
              ))}
            </Grid>
          </Box>
        ) : (
          <Box mt={3}>
            {isEmpty(courses) ? (
              <NoData message="Nenhum curso encontrado" />
            ) : (
              <>
                <Grid container spacing={3}>
                  {courses.map((course) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={course?.id}>
                      <TrainingCourseCard course={course} isEdit={isEdit} />
                    </Grid>
                  ))}
                </Grid>
                <Box className={classes.pagination}>
                  <TablePagination
                    component="div"
                    count={totalCount}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    rowsPerPage={perPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[12, 24, 48]}
                    labelRowsPerPage="Cursos por página"
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}–${to} de ${count}`
                    }
                  />
                </Box>
              </>
            )}
          </Box>
        )}
      </Container>
      {reportDialogOpen && (
        <GenerateReportDialog
          open={reportDialogOpen}
          onClose={() => setReportDialogOpen(false)}
        />
      )}
      <Filters filter={filter}>
        <input textfieldinput="true" label="Título" name="title" />
        <select textfieldinput="true" label="Categoria" name="category_id">
          <option value=""></option>
          {categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
      </Filters>
    </Page>
  )
}

export default TrainingCoursesMain
